import { render, staticRenderFns } from "./basic-videopicstext-swiper-new-keji.vue?vue&type=template&id=dd6462dc&scoped=true"
import script from "./basic-videopicstext-swiper-new-keji.vue?vue&type=script&lang=js"
export * from "./basic-videopicstext-swiper-new-keji.vue?vue&type=script&lang=js"
import style0 from "./basic-videopicstext-swiper-new-keji.vue?vue&type=style&index=0&id=dd6462dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6462dc",
  null
  
)

export default component.exports